import { render, staticRenderFns } from "./ResumePage.vue?vue&type=template&id=5fcec1e4"
import script from "./ResumePage.vue?vue&type=script&lang=js"
export * from "./ResumePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports